import React, { Fragment } from 'react';
import './ModuleContainer.scss';
import PropTypes from 'prop-types';

const ModuleContainer = ({ children, highlighted }) => (
  <Fragment>
    <section className={highlighted ? 'module-container--highlighted' : ''}>
      <div className="module-container">{children}</div>
    </section>
  </Fragment>
);

ModuleContainer.propTypes = {
  highlighted: PropTypes.bool
};

ModuleContainer.defaultProps = {
  highlighted: false
};

export default ModuleContainer;
